<template>
  <base-section
    id="about-us"
    class="grey lighten-3"
  >
    <base-section-heading
      v-intersect.quiet="{
        handler: onIntersect,
        options: {
          threshold: [0.5]
        }
      }"
      color="primary"
      icon="mdi-human-greeting"
      title="Who we are"
    >
      We are a young startup formed by Argentine software engineers.
    </base-section-heading>

    <v-container>
      <v-row>
        <v-col
          v-for="card in cards"
          :key="card.title"
          cols="12"
          md="6"
        >
          <base-info-card
            v-bind="card"
            align="center"
          />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  import { eventBus } from '../../main'

  export default {
    name: 'SectionAboutUs',

    data: () => ({
      cards: [
        {
          title: 'Professionals',
          subtitle: 'We are modern',
          text: 'We complement each other professionally and personally to manage software projects, develop products and provide quality services. We apply engineering to software development and all the operations that it involves, working with agile methodologies and modern technologies.',
        },
        {
          title: 'Entrepreneurs',
          subtitle: 'We are passionate',
          text: 'We are entrepreneurs and passionate about what we do. We enjoy the analysis, design, development, and implementation of software solutions, learning more and better ways to do it every day. We like to keep up to date and aware of the best practices.',
        },
      ],
    }),
    methods: {
      onIntersect (entries, observer) {
        if (entries[0].intersectionRatio >= 0.5) {
          eventBus.$emit('selectTab', 'about')
        }
      },
    },
  }
</script>
